module.exports = __webpack_public_path__ + "officialStatic/img/detail-one2.2dda6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-one2.png
// module id = HZf1
// module chunks = 0